import {action} from 'mobx'
import store from '../store'
import { UT } from 'core/constants'
import { ccpProvider } from 'core/CcpProvider'
import sessionxtd from 'core/sessionxtd'

export default class User {

  @action
  markUserAsBlocked(blockType = '') {
    store.user.block = true
    store.user.blockType = blockType
  }
  @action
  markUserAsSecondBlocked() {
    store.user.secondBlock = true
  }

  @action
  markUserAsUnBlocked() {
    store.user.block = false
    store.user.secondBlock = false
    store.user.blockType = ''
  }

  @action
  markUserAsPremium() {
    store.user.premium = true
  }

  @action
  markUserAsFree() {
    store.user.premium = false
  }

  @action
  setAccountType() {
    store.account.type = UT.USER
  }

  @action
  toggleRecurringBlock(enabled) {
    if (enabled) {
      store.user.block = false
      store.user.blockType = null
    } else {
      store.user.block = true
      store.user.blockType = 'blockRebill'
    }
  }

  @action
  contactInfoDetected(data) {
    const conversation = store.conversations.find(c => c.conversationUid === data.conversationUid)
    const msg = {
      id: data.messageId,
      sentBy: null,
      message: 'contactInfoDetected',
      sentAt: Math.floor((Date.now()) / 1000),
      conversationUid: data.conversationUid,
      type: 'contactInfoDetected',
    }

    conversation.addMessage(msg)
  }

  @action
  updateUserCache() {
    const cacheKey = ccpProvider.api.generateCacheKey(ccpProvider.api.widget.endpoints.WIDGET_GET_CONVERSATIONS, { userUid: CONFIG.userUid })
    const userConversationsCache = sessionxtd.getItem(cacheKey, true)
    if (!userConversationsCache) {
      return
    }
    const { item, expiration } = userConversationsCache

    sessionxtd.setItem(cacheKey, { ...item, ...store.user }, 0, expiration)
  }
}
